import { DateAdapter, NativeDateAdapter } from "@angular/material/core";
import { inject, Injectable, Provider } from "@angular/core";
import { FormattingService } from "root/services";
@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {

  private formattingService = inject(FormattingService);
  
  constructor() {
    super();
  }

  // set Monday as first day of week instead of Sunday
  getFirstDayOfWeek(): number {
    return 1;
  }

  format(date: Date): string {
    return this.formattingService.formatDate(date, null, true);
  }
}

/**
 * Provider function for CustomDateAdapter to be used in the app
 * @returns Custom DateAdapter for showing dates as per user settings
 */
export function provideMibpDateAdapter(): Provider[] {
  return [
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter
    }
  ];
}
